import {useApiContainer, useUserInfo} from '@ozark/common';
import {CancelOperationMessage} from '@ozark/common/api/Constants';
import {SearchCriteria} from '@ozark/common/api/SearchCriteria';
import {EquipmentExpenseResidualsTotals} from '@ozark/common/components';
import {CancelTokenSource} from 'axios';
import {useEffect, useState} from 'react';
import {useStore} from '../../../store/helpers';
import {hasResidualsPermissions} from '../../../utils/hasResidualsPermissions';

export const RedisualsExpenseCriteria: SearchCriteria = {
  limit: 1, // page size
  offset: 1, // page
  order: 'desc',
  orderBy: 'yearMonth',
};

export const useNavigationPermissions = () => {
  const {isAgent} = useUserInfo();
  const {authProfile} = useStore();
  const api = useApiContainer();
  const [, setCancelTokenSource] = useState<CancelTokenSource | undefined>();
  const [isTerminalScheduleAEnabled, setIsTerminalScheduleAEnabled] = useState<boolean>(false);

  const getResiduals = () => {
    const cancelSource = api?.residuals.getCancelTokenSource();
    setCancelTokenSource((prev: any) => {
      //bCheck if there are any previous pending requests
      if (prev !== undefined) {
        console.log('cancel');
        prev.cancel(CancelOperationMessage);
      }
      return cancelSource;
    });

    api?.residuals
      .getEquipmentExpenseResiduals(
        RedisualsExpenseCriteria,
        undefined,
        undefined,
        undefined,
        cancelSource?.token
      )
      .then((result: any) => {
        const totals = result as EquipmentExpenseResidualsTotals;
        const isEnabled =
          totals.equipmentAgentExpenseTotal > 0 ||
          totals.valorEquipmentAgentExpenseTotal > 0 ||
          totals.dejavooEquipmentAgentExpenseTotal > 0 ||
          totals.valorAdditionalEquipmentAgentExpenseTotal > 0 ||
          totals.dejavooAdditionalEquipmentAgentExpenseTotal > 0;
        setIsTerminalScheduleAEnabled(isEnabled);
      })
      .catch((err: any) => {
        if (err?.message === CancelOperationMessage) {
          return;
        }
        console.error(err);
        setIsTerminalScheduleAEnabled(false);
      });
  };

  useEffect(() => {
    if (!authProfile.data || !isAgent || !hasResidualsPermissions(authProfile.data)) {
      return;
    }
    getResiduals();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authProfile, isAgent]);

  return {
    isTerminalScheduleAEnabled,
  };
};
